module.exports = {
   notify: function (type,title, message) {
      Event.$emit('addNotification', {
         type: type,
         title: title,
         message: message,
      });
   }
}